export const container = () => ({
    display: 'inline-block',
    padding: '1.5rem',
    width: '9.375rem',
});

export const singleColor = ({ theme: { colors }, colorName }) => ({
    background: colors[colorName],
    width: '100%',
    height: '7.875rem',
    borderRadius: '7px',
});
